import { useEffect, useRef } from "react";

import useAxiosPrivate from "@/api/hooks/useAxiosPrivate";
import Table from "@/components/Table/Table";
import useResponse from "@/shared/hooks/useResponse";
import { useUsersTableStore } from "@/stores/useTableStore";

import LayoutWrapper from "../../components/Layout/LayoutWrapper";
import UsersHeaderActions from "../../components/PageHeader/actions/pageHeaderActions/UsersHeaderActions/UsersHeaderActions";
import TabFilters from "../../components/TabFilters/TabFilters";
import EditUserDialog from "../../components/Table/actions/dialogs/Users/EditUserDialog/EditUserDialog";
import useUsersInlineActions from "../../components/Table/actions/inlineActions/hooks/useUsersInlineActions";
import { useAuth } from "../../context/Auth/AuthProvider";
import { ROUTES, TABLE_NAMES } from "../../shared";
import { useReleaseFeatureToggle } from "../../shared/featureToggles/hooks";
import { FEATURE_NAMES } from "../../shared/featureToggles/types";

import { USERS_PAGE_TABS } from "./UsersInvitations/config";

const Users = () => {
  const { user } = useAuth();
  const { getData } = useAxiosPrivate();
  const { handleResponse } = useResponse();
  const { setIsCheckable, setInlineActions, resetInitialLoading, fetchData } =
    useUsersTableStore();

  const { isReleaseFeatureEnabledForUser } = useReleaseFeatureToggle();

  const isAllowedFullControlOfUsers = isReleaseFeatureEnabledForUser(
    FEATURE_NAMES.AllowedFullControlOfUsers,
    user?.email
  );

  const { inlineActions, rowData, isOpen, closeDialog } = useUsersInlineActions(
    isAllowedFullControlOfUsers
  );

  const hasFetched = useRef(false);

  useEffect(() => {
    if (!hasFetched.current) {
      resetInitialLoading();
      hasFetched.current = true;
      handlePageLoad();
    }
  }, []);

  const handlePageLoad = async () => {
    await fetchData(getData, handleResponse);
    setIsCheckable(true);
    setInlineActions(inlineActions);
  };

  return (
    <>
      <LayoutWrapper
        showDetailsSection={false}
        tableName={TABLE_NAMES.Users}
        route={ROUTES.Users}
      >
        <UsersHeaderActions currentRoute={ROUTES.Users} />
      </LayoutWrapper>
      <Table
        route={ROUTES.Users}
        hideFilters
        hasDetails={false}
        tabFilters={<TabFilters tabs={USERS_PAGE_TABS} />}
        hasTabFilters
      />

      {/* inline action dialog */}
      {rowData && (
        <EditUserDialog
          isOpen={isOpen}
          onClose={closeDialog}
          rowData={rowData}
        />
      )}
    </>
  );
};

export default Users;
